import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ModalOptions } from 'ngx-bootstrap';

import { DocumentTemplate } from '../../models/index';
// TODO: ld-tooltip & ld-modal will be replaced by ula-modal; this is a breaking change
import { LDModalComponent } from '../../../ld-angular-components/components/modal/ld-modal.component';
import { UlaPdfComponent } from '../../ula-pdf/ula-pdf.component';

enum ModalType {
  None = <any>'None',
  Disclosure = <any>'Disclosure',
  PDF = <any>'PDF',
  Image = <any>'Image'
}

@Component({
  selector: 'ld-disclosure-modal',
  templateUrl: './disclosure-modal.template.html',
  styleUrls: [ './disclosure-modal.style.scss' ]
})
export class DisclosureModalComponent {
  @Input() disableFooter = false;
  @Input() disableCloseButton = true;
  @Input() cancelBtnDisabled = true;
  @Input() cancelBtnText = '';
  @Input() submitBtnDisabled = false;
  @Input() submitBtnText = '';
  @Input() backdropBehindModal = false;
  @Input() padding = false;
  @Input() width = 0;
  @Input() isErrorDialogModal = false;
  @Input() config: ModalOptions = {};
  @Input() disclosureNotice = '';

  @Output() cancel: EventEmitter<null> = new EventEmitter<null>();
  @Output() hidden: EventEmitter<null> = new EventEmitter<null>();
  @Output() submit: EventEmitter<null> = new EventEmitter<null>();
  @Output() shown: EventEmitter<null> = new EventEmitter<null>();
  @Output() scrolledToBottom: EventEmitter<null> = new EventEmitter<null>();

  @ViewChild('modal') modal: LDModalComponent;
  @ViewChild('body') body: ElementRef;
  @ViewChild('pdfComponent') pdfComponent: UlaPdfComponent;

  public isContentSet = false;
  private _modalTitle: string;
  private modalType: ModalType = ModalType.None;
  private _document: DocumentTemplate;
  public _pdfData: string;
  public _imageURL: SafeResourceUrl;

  public set modalTitle(value: string) {
    this._modalTitle = value;
  }

  private clearContents() {
    this.isContentSet = false;
    this._document = null;
    this._imageURL = null;
    this._pdfData = null;
  }

  private setContentType(type: ModalType) {
    this.modalType = type;
    this.isContentSet = true;
  }

  public set documentTemplate(value: DocumentTemplate) {
    this.clearContents();
    this.setContentType(ModalType.Disclosure);
    this._document = value;
    this.modalTitle = value.name;
  }

  public set pdfData(value: string) {
    this.clearContents();
    this._pdfData = value;
    this.setContentType(ModalType.PDF);
  }

  public set imageURL(value: SafeResourceUrl) {
    this.clearContents();
    this._imageURL = value;
    this.setContentType(ModalType.Image);
  }

  public show(): void {
    switch (this.modalType) {
      case ModalType.PDF:
        break;
      case ModalType.Disclosure:
        this.body.nativeElement.innerHTML = this._document.htmlTemplate;
        break;
    }

    this.modal.show();
  }

  public hide(): void {
    this.modal.hide();
  }

  public onCancel(): void {
    this.cancel.emit();
  }

  public onHidden(): void {
    this.hidden.emit();
  }

  public onSubmit(): void {
    this.submit.emit();
  }

  public onShown(): void {
    this.shown.emit();
  }

  public onScrolledToBottom(): void {
    this.scrolledToBottom.emit();
  }

  public print(): void {
    if (this.modalType === ModalType.Disclosure || this.modalType === ModalType.Image) {
      const tempWindow = window.open('', 'PRINT');

      tempWindow.document.write('<html><head><title>' + this._modalTitle + '</title></head>');

      if (this.modalType === ModalType.Image) {
        tempWindow.document.write('<body style="text-align: center">');
      } else {
        tempWindow.document.write('<body>');
      }

      tempWindow.document.write(this.body.nativeElement.innerHTML);
      tempWindow.document.write('</body></html>');

      tempWindow.document.close();
      tempWindow.focus();
      tempWindow.print();
      tempWindow.close();
    } else {
      this.pdfComponent.print();
    }
  }
}
